import React, { useEffect, useState } from "react";
import Fade from 'react-reveal/Fade';
import "../../stylesheet/Wsaller.css";
import { Link, useLocation } from "react-router-dom";

const Wsaller = () => {

  const [isVisible, setIsVisible] = useState(false);
  const [isVisible2, setIsVisible2] = useState(false);
  const [isVisible3, setIsVisible3] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(10, 0);
  }, [pathname]);

  useEffect(() => {
    // Add a scroll event listener to check when the component is in the viewport
    const handleScroll = () => {
      const element = document.getElementById('scroll-fade');
      const element2 = document.getElementById('scroll-fade2');
      const element3 = document.getElementById('scroll-fade3');
if( window.innerWidth > 1340) {

  
  if (element) {
    const rect = element.getBoundingClientRect();
    const isVisible = rect.top <= window.innerHeight;
    setIsVisible(isVisible);
  }
  if (element2) {
    const rect = element2.getBoundingClientRect();
    const isVisible2 = rect.top <= window.innerHeight;
    setIsVisible2(isVisible2);
  }
  if (element3) {
    const rect = element3.getBoundingClientRect();
    const isVisible3 = rect.y;
    setIsVisible3(isVisible3);
  } 

} else {
  if (element) {
    const rect = element.getBoundingClientRect();
    const isVisible = rect.top < window.innerHeight;
    window.removeEventListener('scroll', handleScroll);
    setIsVisible(isVisible);
  }
  if (element2) {
    const rect = element2.getBoundingClientRect();
    const isVisible2 = window.innerHeight;
    window.removeEventListener('scroll', handleScroll);
    setIsVisible2(isVisible2);
  }
  if (element3) {
    const rect = element3.getBoundingClientRect();
    const isVisible3 =  window.innerHeight;
    window.removeEventListener('scroll', handleScroll);
    setIsVisible3(isVisible3);
  }
}
};

    // Attach the scroll event listener
    window.addEventListener('scroll', handleScroll);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  });



  return (
    <div id="wlb-cont">


      <div id="wl-sec-1">
        <div className="ws-l">
          <div className="ws-title">
            Our
            <br />
            Wholesaler
            <br />
            Plans !!!
          </div>

          <div className="btn btn-b">Explore</div>
          <div className="ar-1">
            <img src="./imgs/wsl-a.jpg" alt="" />
          </div>
        </div>
        <div className="ws-r">
          <img src="./imgs/wsl1.jpg" alt="" />
        </div>
      </div>


<div id="scroll-fade2">
        <Fade bottom when={isVisible3}>
      <div id="wl-sec-2">
        <h1>How we create your brand</h1>
        <div className="hwcb-grid">
          <div className="hwcb">
            <img src="./imgs/whc-1.jpg" alt="" />
            <p>
              MAIL US YOUR NEED AND WE'LL RRVERT YOU BACK WITH THE BEST SOLUTION
            </p>
          </div>
          <div className="hwcb">
            <img src="./imgs/whc-2.jpg" alt="" />
            <p>
              OUR EXPERT TEAM WILL HELP YOU IN CREATING YOUR PERSONALIZE BRAND
            </p>
          </div>
          <div className="hwcb">
            <img src="./imgs/whc-3.jpg" alt="" />
            <p>YOUR BRAND IS MARKET READY TO GRAB CUSTOMER'S ATTENTION </p>
          </div>
        </div>
      </div>
      </Fade>
      </div>


      <div id="scroll-fade3">
      <Fade bottom when={isVisible3}>
      <div id="wl-sec-3">
        <div className="ws-l">
          <div className="wsl-title">
            Lets
            <br />
            Collaborate!!!
          </div>
          <div className="ar-1 ar-2">
            <img src="./imgs/wsl-a2.jpg" alt="" />
          </div>
          <div className="wsl-qr">
            <img src="./imgs/wqr.jpg" alt="" />
            <big>Scan Our Whatsapp QR</big>
          </div>
        </div>
        <div className="ws-r">
          <img src="./imgs/wsl2.jpg" alt="" />
        </div>
      </div>
      </Fade>
      </div>
    </div>
  );
};

export default Wsaller;
